import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { ngHelper } from '@cakeiteasy/web-utils';
import { PAYMENT_PLATFORM_TYPES } from '../../payment.constants';
import { IPaymentMethodDesc } from '../../models/i-payment-models';
import { IUser } from '../../../users';

@Component({
  standalone: false,
  selector: 'choose-payment-type',
  templateUrl: './choose-payment-type.component.html',
  styleUrls: ['./choose-payment-type.component.scss']
})
export class ChoosePaymentTypeComponent implements OnChanges {
  public type: string;

  // TODO rewrite user as @Input instead of direct store access
  public PAYMENT_PLATFORM_TYPES = PAYMENT_PLATFORM_TYPES;

  @Input() public user: IUser;
  @Input() public paymentMethods: IPaymentMethodDesc[];
  @Input() public paymentTypeChecker: (type: string) => Promise<any>;
  @Input() public btnColor: 'primary' | 'secondary' | 'outline-primary' | 'outline-secondary' = 'outline-primary';
  @Input() public size: 'lg' | 'xl' = 'xl';
  @Input() public blockedOptions: string[];

  @Input()
  public get paymentType() {
    return this.type;
  }

  public set paymentType(type: string) {
    const currentType = this.type;
    let promise = Promise.resolve(type);

    if (typeof this.paymentTypeChecker === 'function') {
      promise = this.paymentTypeChecker(type);
    }

    promise
      .then(() => {
        this.type = type;
        if (this.type !== currentType) {
          this.paymentTypeChange.emit(type);
        }
      })
      .catch(() => {
        console.log('Payment type was\' changed due to checker');
        return null;
      });
  }

  @Output() paymentTypeChange = new EventEmitter<string>();

  public ngOnChanges(changes: SimpleChanges): void {
    ngHelper.ifChanged(changes, 'user', (user) => {
      if (!user && this.paymentType === this.PAYMENT_PLATFORM_TYPES.invoice) {
        this.paymentType = '';
      }
    });
  }

  public isBlocked(type: string) {
    return this.blockedOptions && this.blockedOptions.indexOf(type) !== -1;
  }
}
